import { Minus, Plus } from "lucide-react";
import { quantityNumber, sanitizeQuantity, stepQuantity } from "../quantity";
import { t as translate } from "../preferences";

export function QuantityStepper({
  value,
  onChange,
  label,
  disabled = false,
  onDecrement,
  max,
  inline = false,
}: {
  value: string;
  onChange: (value: string) => void;
  label: string;
  disabled?: boolean;
  onDecrement?: () => void;
  max?: number;
  inline?: boolean;
}) {
  function change(next: string) {
    onChange(max !== undefined && quantityNumber(next) > max ? String(max) : next);
  }
  return <div className={inline ? "m-return-stepper" : undefined}>
    <span className={inline ? "m-shrink-0 m-text-xs m-font-bold" : "m-field-label"}>{label}</span>
    <div className={inline ? "m-return-stepper-controls" : "m-flex m-items-center m-gap-2"}>
      <button
        type="button"
        className={`m-flex ${inline ? "m-size-9" : "m-size-11"} m-shrink-0 m-items-center m-justify-center m-rounded-xl m-border m-border-border m-bg-surface`}
        aria-label={translate("Miqdorni kamaytirish")}
        disabled={disabled}
        onClick={() => onDecrement ? onDecrement() : change(stepQuantity(value, -1))}
      >
        <Minus className="m-size-4" />
      </button>
      <input
        className={inline ? "m-text-input m-return-quantity-input m-text-center m-tabular-nums" : "m-text-input m-min-w-0 m-flex-1 m-text-center m-tabular-nums"}
        style={inline ? { width: `calc(${Math.max(3, value.length + 1)}ch + 0.75rem)` } : undefined}
        aria-label={label}
        inputMode="decimal"
        disabled={disabled}
        value={value}
        onChange={(event) => change(sanitizeQuantity(event.target.value))}
      />
      <button
        type="button"
        className={`m-flex ${inline ? "m-size-9" : "m-size-11"} m-shrink-0 m-items-center m-justify-center m-rounded-xl m-border m-border-border m-bg-surface`}
        aria-label={translate("Miqdorni oshirish")}
        disabled={disabled || (max !== undefined && quantityNumber(value) >= max)}
        onClick={() => change(stepQuantity(value, 1))}
      >
        <Plus className="m-size-4" />
      </button>
    </div>
  </div>;
}

export function shouldRemoveOnDecrement(value: string): boolean {
  return quantityNumber(value) <= 1;
}
